export default class Currency {
    constructor(data) {
        this.code = data.code;
        this.name = data.name;
        this.symbol = data.symbol;
    }
    static get euro() {
        return new Currency({
            code: 'EUR',
            name: 'Euro',
            symbol: '€'
        });
    }
}
//# sourceMappingURL=currency.js.map